// @ts-nocheck
// 导入 抽取的 请求对象
import ajaxRequest from '@/utils/request';
import { getToken } from '../utils/token';

const reFix = 'useradmin';

// 获取经纪人人员列表
export function getAgentSerApi(params) {
  return ajaxRequest({
    url: reFix + '/Agent/get_agent_list',
    params: { ...params },
    headers: {
      houseId: JSON.parse(getToken('userInfo')).houseId,
    },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 导出经纪人人员列表
export function exportAgentSerApi(params) {
  return ajaxRequest({
    url: reFix + '/Agent/downLoad',
    params,
    headers: {
      houseId: JSON.parse(getToken('userInfo')).houseId,
    },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// // 修改经纪人人员
// export function setAgentSerApi(data) {
//     return ajaxRequest({
//         url: reFix + "/CustSer",
//         method: 'PUT',
//         data,
//         // 跨域 是否携带 cookie
//         withCredentials: true
//     })
// }

// // 新增经纪人人员
// export function addAgentSerApi(data) {
//     return ajaxRequest({
//         url: reFix + "/CustSer",
//         method: 'POST',
//         data,
//         // 跨域 是否携带 cookie
//         withCredentials: true
//     })
// }

// // 删除经纪人人员
// export function deleteAgentSerApi(custSerId) {
//     let data = 'custSerId=' + custSerId
//     return ajaxRequest({
//         url: reFix + "/CustSer",
//         method: 'DELETE',
//         data,
//         headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
//         // 跨域 是否携带 cookie
//         withCredentials: true
//     })
// }
